export default { sha: 'e6232d3292df87346ac3f20eea9c899116792def', buildNumber: 'undefined' }
